import React from "react";


export default function SlideCard(props) {
  const {selected, handleSelectPlan, value} = props;
  return (
    <div
      className={`slide-card ${selected ? "plan-selected" : ""}`}
      onClick={e => {
        handleSelectPlan(value);
      }}
      id={props.id}
      key={props.id}
    >
      <p className="card-cost">
        <span className="cost">
          {`$${props.price}`}
        </span>
        <br/>
        {"/mos"}
      </p>
      <p className="card-detail">
        {props.description}
      </p>
    </div>
  );
}
